import { Controller } from "@hotwired/stimulus";

// FAQモーダルの制御を行うStimulusコントローラー
export default class extends Controller {
  connect() {
    this.loading = $(
      '<div class="text-center my-3"><div class="spinner-border text-info" role="status"><span class="sr-only">Loading...</span></div></div>',
    );

    this.content = $(this.element.querySelector(".modal-content"));
    $(this.element).on("show.bs.modal", this.#fetch);
  }

  disconnect() {
    $(this.element).off("show.bs.modal", this.#fetch);
  }

  #fetch = (ev) => {
    this.content.html(this.loading);
    const faqUrl = ev.relatedTarget.href;

    $.ajax({
      url: faqUrl,
      success: (data) => {
        this.content.hide();
        this.content.html(data);
        this.content.fadeIn(333);
      },
    });
  };
}
